var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMildewResitant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.11 174.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#696a6c;}.cls-2{stroke:#696a6c;stroke-linejoin:bevel;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.15,177.08A87.06,87.06,0,1,1,166.27,48h0A87,87,0,0,1,90.15,177.08ZM89.89,9.92a80.1,80.1,0,1,0,70.25,41.49h0a79.53,79.53,0,0,0-47.86-38.29A80.35,80.35,0,0,0,89.89,9.92Z",
    transform: "translate(-2.94 -2.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.11,56.3a5.58,5.58,0,1,1,5.57-5.58A5.58,5.58,0,0,1,64.11,56.3Zm0-8.75a3.18,3.18,0,1,0,3.17,3.17A3.17,3.17,0,0,0,64.11,47.55Z",
    transform: "translate(-2.94 -2.92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.58,72.54c-2.74,0-5-2.66-5-5.93s2.23-5.94,5-5.94,5,2.66,5,5.94S55.33,72.54,52.58,72.54Zm0-9.47c-1.39,0-2.57,1.62-2.57,3.54s1.18,3.53,2.57,3.53,2.58-1.62,2.58-3.53S54,63.07,52.58,63.07Z",
    transform: "translate(-2.94 -2.92)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.26,55.71a5.37,5.37,0,1,1,5.37-5.37A5.37,5.37,0,0,1,44.26,55.71Zm0-8.34a3,3,0,1,0,3,3A3,3,0,0,0,44.26,47.37Z",
    transform: "translate(-2.94 -2.92)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.37,109.75a5.57,5.57,0,1,1,7.83.89A5.58,5.58,0,0,1,60.37,109.75Zm6.84-5.44a3.17,3.17,0,1,0-.5,4.45A3.16,3.16,0,0,0,67.21,104.31Z",
    transform: "translate(-2.94 -2.92)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.81,90.36c-1.71-2.15-1-5.55,1.55-7.59s6-2,7.74.2,1,5.55-1.55,7.59S58.52,92.51,56.81,90.36Zm7.41-5.89c-.86-1.1-2.86-1-4.36.18s-2,3.13-1.17,4.22,2.87,1,4.37-.19S65.09,85.56,64.22,84.47Z",
    transform: "translate(-2.94 -2.92)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.55,70.33a5.37,5.37,0,1,1,7.55.86A5.38,5.38,0,0,1,67.55,70.33Zm6.53-5.19a3,3,0,1,0-.48,4.17A3,3,0,0,0,74.08,65.14Z",
    transform: "translate(-2.94 -2.92)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.48,102.88a5.57,5.57,0,1,1,5.82,5.32A5.58,5.58,0,0,1,40.48,102.88Zm8.74-.39a3.17,3.17,0,1,0-3,3.31A3.18,3.18,0,0,0,49.22,102.49Z",
    transform: "translate(-2.94 -2.92)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.73,92.1c-.13-2.74,2.43-5.09,5.7-5.24s6,2,6.16,4.7-2.44,5.1-5.71,5.24S23.85,94.84,23.73,92.1Zm9.46-.43c-.06-1.39-1.73-2.49-3.65-2.41S26.06,90.6,26.13,92s1.73,2.5,3.65,2.41S33.25,93.07,33.19,91.67Z",
    transform: "translate(-2.94 -2.92)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.1,79.86A5.37,5.37,0,1,1,44.71,85,5.38,5.38,0,0,1,39.1,79.86Zm8.33-.38a3,3,0,1,0-2.83,3.1A3,3,0,0,0,47.43,79.48Z",
    transform: "translate(-2.94 -2.92)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.2,54.65A5.57,5.57,0,1,1,104,60,5.58,5.58,0,0,1,98.2,54.65Zm8.73-.39a3.17,3.17,0,1,0-3,3.31A3.17,3.17,0,0,0,106.93,54.26Z",
    transform: "translate(-2.94 -2.92)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.59,52c-.12-2.74,2.44-5.09,5.71-5.24s6,2,6.15,4.7-2.43,5.09-5.7,5.24S78.71,54.71,78.59,52Zm9.46-.43C88,50.15,86.32,49,84.4,49.13S80.93,50.47,81,51.86s1.73,2.5,3.65,2.41S88.12,52.94,88.05,51.54Z",
    transform: "translate(-2.94 -2.92)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.77,33a5.37,5.37,0,1,1,5.6,5.12A5.37,5.37,0,0,1,77.77,33Zm8.33-.37a3,3,0,1,0-2.83,3.1A3,3,0,0,0,86.1,32.59Z",
    transform: "translate(-2.94 -2.92)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.56,128.53a1,1,0,0,1-.43-.1,31.7,31.7,0,0,1-18.25-25.66l-1.62-17a1,1,0,0,1,.63-1l19.28-8.06a1.08,1.08,0,0,1,.79,0l19.28,8.06a1,1,0,0,1,.63,1l-1.62,17A31.68,31.68,0,0,1,108,128.43.94.94,0,0,1,107.56,128.53ZM89.38,86.28l1.54,16.3a29.67,29.67,0,0,0,16.64,23.79,29.67,29.67,0,0,0,16.64-23.79l1.55-16.3-18.19-7.6Z",
    transform: "translate(-2.94 -2.92)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.56,139.86a1.23,1.23,0,0,1-.42-.07,43.22,43.22,0,0,1-27.8-36.37L77,78.78a1.2,1.2,0,0,1,.73-1.22L107.1,65.29a1.25,1.25,0,0,1,.93,0l29.36,12.27a1.19,1.19,0,0,1,.73,1.22l-2.33,24.64A43.22,43.22,0,0,1,108,139.79,1.25,1.25,0,0,1,107.56,139.86ZM79.48,79.44l2.25,23.75a40.83,40.83,0,0,0,25.83,34.19,40.82,40.82,0,0,0,25.84-34.19l2.25-23.75L107.56,67.7Z",
    transform: "translate(-2.94 -2.92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMildewResitant);
export default __webpack_public_path__ + "static/media/mildew-resitant.ddeb2201b7fe5bd8ee71449eb1efc097.svg";
export { ForwardRef as ReactComponent };